export enum PaymentType {
  Electronic = 100,
  Cash = 200,
  // ReSharper disable once InconsistentNaming
  EFT = 300,
  Credit = 400,
  TBC = 500,
  Internal = 600,
}
